import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles.css';
import './styles/woriva-theme.css';
import './styles/woriva-polish.css';
import App from './app/App';
import { SessionProvider } from './app/SessionProvider';
import { ErrorBoundary } from './components/ui';
import { ServiceWorkerProvider } from './app/ServiceWorkerProvider';
import { WorkflowSafetyProvider } from './app/WorkflowSafety';
import { lockViewportZoom } from './app/lockViewportZoom';

async function start() {
  lockViewportZoom();
  if (__MOCK__) { const { worker } = await import('./testing/browser'); await worker.start({ onUnhandledRequest: 'bypass' }); }
  const client = new QueryClient();
  ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><ErrorBoundary><QueryClientProvider client={client}>
    <HashRouter><ServiceWorkerProvider><WorkflowSafetyProvider><SessionProvider><App /></SessionProvider></WorkflowSafetyProvider></ServiceWorkerProvider></HashRouter></QueryClientProvider></ErrorBoundary></React.StrictMode>);
}
void start();
